function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef } from 'react';
import { StyleSheet, View, TouchableOpacity, Animated } from 'react-native';
import { Check } from '@suranceadmin/icons/native';
import { withTheme } from '../../core/theming';
const dimensions = {
  width: 40,
  circleWidth: 24,
  circleHeight: 24,
  translateX: 24
};

const switchAccessibilityState = isOn => {
  const accessbilityState = {
    accessibilityState: {
      checked: isOn
    }
  };
  return accessbilityState;
};

const Switch = props => {
  const {
    isOn = false,
    onToggle = () => undefined,
    thumbOnStyle,
    thumbOffStyle,
    trackOnStyle,
    trackOffStyle,
    icon,
    disabled = false,
    theme: {
      colors,
      isRTL
    },
    accessibility
  } = props;
  let toValue;
  const offsetX = useRef(new Animated.Value(0)).current;
  const switchIcon = icon || /*#__PURE__*/React.createElement(Check, {
    width: 12,
    color: colors.background.white
  });

  const createTrackStyle = () => [styles.track, {
    backgroundColor: colors.button.disabled
  }, isOn ? trackOnStyle : trackOffStyle];

  const createThumbStyle = () => [styles.thumb, {
    backgroundColor: isOn ? colors.text.link : colors.text.disabled,
    transform: [{
      translateX: offsetX
    }]
  }, isOn ? thumbOnStyle : thumbOffStyle];

  if (!isRTL && isOn) {
    toValue = dimensions.width - dimensions.translateX;
  } else if (isRTL && isOn) {
    toValue = -dimensions.width + dimensions.translateX;
  } else {
    toValue = 0;
  }

  Animated.timing(offsetX, {
    toValue,
    useNativeDriver: true,
    duration: 300
  }).start();
  return /*#__PURE__*/React.createElement(View, _extends({
    style: styles.container
  }, props), /*#__PURE__*/React.createElement(TouchableOpacity, _extends({}, accessibility, switchAccessibilityState(isOn), {
    accessibilityRole: 'switch',
    style: createTrackStyle(),
    activeOpacity: 0.8,
    onPress: () => disabled ? null : onToggle(!isOn)
  }), /*#__PURE__*/React.createElement(Animated.View, {
    style: createThumbStyle()
  }, isOn && switchIcon)));
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  track: {
    justifyContent: 'center',
    width: 40,
    borderRadius: 20,
    paddingVertical: 12,
    paddingHorizontal: 10
  },
  thumb: {
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    left: 0,
    position: 'absolute',
    width: dimensions.circleWidth,
    height: dimensions.circleHeight,
    borderRadius: dimensions.circleWidth / 2,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 2.5,
    elevation: 1.5
  }
});
export default withTheme(Switch);
//# sourceMappingURL=index.js.map